import { Components, Theme } from '@mui/joy';

export const JoyMenuItemConfig: Partial<Components<Theme>> = {
  JoyMenu: {
    styleOverrides: {
      root: () => {
        return {
          '--ListItem-gap': '4px',
          '&.no-hover': {
            '.MuiMenuItem-root': {
              '&:hover': {
                backgroundColor: 'inherit',
                color: 'inherit',
              },
            },
          },
        };
      },
    },
  },
  JoyMenuItem: {
    styleOverrides: {
      root: () => {
        return {
          '&.Mui-disabled': {
            pointerEvents: 'all',
            '&:hover, &:active': {
              color: 'var(--variant-plainDisabledColor, var(--joy-palette-neutral-plainDisabledColor, var(--joy-palette-neutral-400)))',
              backgroundColor: 'inherit',
            },
          },
          '--Icon-color': 'currentColor',
        };
      },
    },
  },
};
